function GuestLedger() {
    return (
      <>
        <div className="font-bold text-lg mb-16">GuestLedger</div>
      </>
    );
  }
  
  export default GuestLedger;